import {
	DELIVERY_METHOD_KIND,
	type DeliveryMethodKind,
	VENDOR_AGGREGATION_GROUP,
} from "@dransay/api/models";
import type { FiltersState } from "~/features/products/filters/types";
import { MarketConfigs } from "~/tooling/market/config";

type DefaultViewParams = {
	vendorId: string;
	deliveryMethod: DeliveryMethodKind;
	filters: Partial<FiltersState>;
};

export const defaultVendorParamsByMarket: Record<string, DefaultViewParams> = {
	[MarketConfigs.de.code]: {
		vendorId: VENDOR_AGGREGATION_GROUP.TOP,
		deliveryMethod: DELIVERY_METHOD_KIND.SHIPPING,
		filters: { topProducersLowPrice: true },
	},
};
